import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { inject, observer } from "mobx-react";
import { observable, toJS } from "mobx";

import ExportButton from "../ExportButton";
import Loading from "../general/Loading";
import Pagination from "../general/Pagination";
import Filtering from "./Filtering";
import NoData from "./NoData";
import ListOpens from "./ListOpens";
import ListPending from "./ListPending";
import ListProcessed from "./ListProcessed";
import Show from "./Show";
import ScheduleSettings from "./ScheduleSettings";
import { DATETIME, TIME } from "../../utils/dateFormats";

const DataContent = ({ page, data, onShow }) => {
  switch (page) {
    case "open":
      return <ListOpens data={data} onShow={onShow} />;
    case "pending":
      return <ListPending data={data} onShow={onShow} />;
    default:
      return <ListProcessed data={data} onShow={onShow} />;
  }
};

@inject("subRequestStorage")
@observer
class SubRequests extends React.Component {
  @observable request = null;
  @observable showSettings = false;

  currentUserIsSuperadmin = window.Application.currentUser.superadmin;

  render() {
    const { subRequestStorage } = this.props;
    const dataLength = subRequestStorage.data.length;
    const showSettingsButton =
      this.currentUserIsSuperadmin &&
      subRequestStorage.currentUserHasScheduleManageAccess;

    return (
      <div>
        <Filtering
          location={subRequestStorage.location}
          position={subRequestStorage.position}
          locations={subRequestStorage.locations}
          positions={subRequestStorage.filteringPositions}
          currentUserHasScheduleManageAccess={subRequestStorage.currentUserHasScheduleManageAccess}
          page={subRequestStorage.page}
          onChangeLocation={subRequestStorage.setLocation}
          onChangePosition={subRequestStorage.setPosition}
          leftActions={showSettingsButton ? this.renderSettingsButton() : null}
        >
          <ExportButton
            className={classNames(
              "btn btn-grey btn-raised btn-long hidden-xs",
              { disabled: false }
            )}
            url={subRequestStorage.exportUrl}
          />
        </Filtering>

        <ScheduleSettings
          visible={this.showSettings}
          onClose={this.handlerCloseSettings}
        />

        {subRequestStorage.loading ? (
          <Loading loading={true} />
        ) : dataLength > 0 ? (
          <DataContent
            page={subRequestStorage.page}
            data={subRequestStorage.data}
            onShow={this.handlerShow}
          />
        ) : (
          <NoData page={subRequestStorage.page} />
        )}

        {subRequestStorage.totalPages > 1 ? (
          <Pagination
            totalPages={subRequestStorage.totalPages}
            page={subRequestStorage.currentPage}
            changePage={subRequestStorage.changePage}
          />
        ) : null}

        <Show
          show={!!this.request}
          request={toJS(this.request)}
          queue={subRequestStorage.page === "open"}
          onClose={this.handlerClose}
          onAction={this.handlerAction}
        />
      </div>
    );
  }

  renderSettingsButton = () => (
    <button
      className="btn btn-default margin-right-five"
      title="Schedule Settings"
      onClick={this.handlerOpenSettings}
    >
      <i className="material-icons md-15 icon-for-dropdown">settings</i>
    </button>
  );

  handlerShow = request => (this.request = request);

  handlerClose = () => (this.request = null);

  handlerOpenSettings = () => (this.showSettings = true);

  handlerCloseSettings = () => (this.showSettings = false);

  handlerAction = (e, note) => {
    e.preventDefault();
    const { subRequestStorage } = this.props;
    const name = e.target.name;

    if (name === 'accept' && !confirm(this.acceptWarning())) {
      return;
    }

    if (subRequestStorage[name]) {
      subRequestStorage[name](this.request, note);
    }

    this.handlerClose();
  };

  acceptWarning = () => {
    const startTime = moment(this.request.shift.start_time).format(DATETIME);
    const endTime = moment(this.request.shift.end_time).format(TIME);
    const locationName = this.request.locationName;
    const positionName = this.request.positionName;

    return `Are you sure you want to accept this Sub Request for ${locationName} - ${[positionName]} at ${startTime} - ${endTime}? Once accepted, this action can only be undone by your supervisor.`;
  }
}

DataContent.propTypes = {
  page: PropTypes.string,
  data: PropTypes.array,
  onShow: PropTypes.func
};

SubRequests.propTypes = {
  locations: PropTypes.array,
  page: PropTypes.string
};

export default SubRequests;
